import ArrowBadgeIcon from "@src/assets/icons/arrow-badge.svg";
import { DigixMilestone, DigixPhase } from "@src/types/project_types";
import { Col, Row } from "antd";

import { DigiXMilestone } from "../digix_milestone";

import "./digix_phase.less";

interface DigiXPhaseProps {
  phase: DigixPhase;
  arrowText: string;
}

const DigiXPhase: React.FC<DigiXPhaseProps> = ({ phase, arrowText }) => {
  return (
    <Row className="digix-phase">
      <Col span={2}>
        <div className="digix-phase__arrow">
          <div className="arrow-text">{arrowText}</div>
          <ArrowBadgeIcon />
        </div>
      </Col>
      <Col span={22}>
        {phase.milestones.map((milestone: DigixMilestone) => (
          <DigiXMilestone key={milestone.id} milestone={milestone} />
        ))}
      </Col>
    </Row>
  );
};

export default DigiXPhase;
